import { COMPONENT_VALUE_TYPES as types, COMPONENT_COLOR_THEMES } from 'shared/constants';

const propsSchema = [
  {
    key: 'scroll_effect',
    label: 'Menu Bar Animation',
    type: types.BOOLEAN
  },
  {
    key: 'color_theme',
    label: 'Color Theme',
    type: types.ENUM,
    options: COMPONENT_COLOR_THEMES
  },
  {
    key: 'version',
    label: 'Version',
    type: types.ENUM,
    options: [1, 2, 3]
  },
  {
    key: 'logo_link',
    label: 'Logo Link',
    type: types.TEXT
  },
  {
    key: 'padding',
    label: 'Padding (V3)',
    type: types.TEXT
  },
  {
    key: 'first_set',
    label: 'First Set Items (v1)',
    type: types.ARRAY,
    options: false,
    children: [
      {
        key: 'url',
        label: 'URL',
        type: types.TEXT,
      },
      {
        key: 'label',
        label: 'Label',
        type: types.TEXT,
      },
      {
        key: 'subnav',
        label: 'Subnav',
        type: types.ARRAY,
        options: false,
        children: [
          {
            key: 'url',
            label: 'URL',
            type: types.TEXT,
          },
          {
            key: 'label',
            label: 'Label',
            type: types.TEXT,
          }
        ]
      }
    ]
  },
  {
    key: 'second_set',
    label: 'Second Set Items (v1)',
    type: types.ARRAY,
    options: false,
    children: [
      {
        key: 'url',
        label: 'URL',
        type: types.TEXT,
      },
      {
        key: 'label',
        label: 'Label',
        type: types.TEXT,
      },
      {
        key: 'loggedInLabel',
        label: 'Logged In Label',
        type: types.TEXT,
      },
      {
        key: 'subnav',
        label: 'Subnav',
        type: types.ARRAY,
        options: false,
        children: [
          {
            key: 'url',
            label: 'URL',
            type: types.TEXT,
          },
          {
            key: 'label',
            label: 'Label',
            type: types.TEXT,
          },
          {
            key: 'loggedInLabel',
            label: 'Logged In Label',
            type: types.TEXT,
          },
        ]
      }
    ]
  },
  {
    key: 'hero_button',
    label: 'Hero Button (v1)',
    type: types.OBJECT,
    children: [
      {
        key: 'url',
        label: 'URL',
        type: types.TEXT,
      },
      {
        key: 'label',
        label: 'Label',
        type: types.TEXT,
      },
      {
        key: 'loggedInLabel',
        label: 'Logged In Label',
        type: types.TEXT,
      },
    ]
  },
  {
    key: 'drawerLinks',
    label: 'Drawer Links (v2, v3)',
    type: types.ARRAY,
    children: [
      {
        key: 'label',
        label: 'Label',
        type: types.TEXT,
      },
      {
        key: 'url',
        label: 'URL',
        type: types.TEXT,
      },
      {
        key: 'target',
        label: 'Target',
        type: types.ENUM,
        options: ['_self', '_blank', '_parent', '_top']
      },
      {
        key: 'loggedInLabel',
        label: 'Logged In Label',
        type: types.TEXT,
      },
      {
        key: 'loggedInLabelUrl',
        label: 'Logged In Label URL',
        type: types.TEXT,
      },
      {
        key: 'subnav',
        label: 'Subnav Items (v3)',
        type: types.ARRAY,
        options: false,
        children: [
          {
            key: 'label',
            label: 'Label',
            type: types.TEXT,
          },
          {
            key: 'url',
            label: 'URL',
            type: types.TEXT,
          },
          {
            key: 'target',
            label: 'Target',
            type: types.ENUM,
            options: ['_self', '_blank', '_parent', '_top']
          },
        ]
      },
      {
        key: 'prompt',
        label: 'Prompt',
        type: types.OBJECT,
        children: [
          {
            key: 'title',
            label: 'Title',
            type: types.TEXT,
          },
          {
            key: 'message',
            label: 'Message',
            type: types.TEXT,
          },
          {
            key: 'actionText',
            label: 'Action Button Text',
            type: types.TEXT,
          },
          {
            key: 'cancelText',
            label: 'Cancel Button Text',
            type: types.TEXT,
          },
        ],
      },
    ]
  },
  {
    key: 'menuLinks',
    label: 'Menu Links (v3) - Desktop navigation',
    type: types.ARRAY,
    options: false,
    children: [
      {
        key: 'label',
        label: 'Label',
        type: types.TEXT,
      },
      {
        key: 'url',
        label: 'URL',
        type: types.TEXT,
      },
      {
        key: 'target',
        label: 'Target',
        type: types.ENUM,
        options: ['_self', '_blank', '_parent', '_top']
      },
      {
        key: 'loggedInLabel',
        label: 'Logged In Label',
        type: types.TEXT,
      },
      {
        key: 'loggedInLabelUrl',
        label: 'Logged In Label URL',
        type: types.TEXT,
      },
      {
        key: 'subnav',
        label: 'Subnav Items',
        type: types.ARRAY,
        options: false,
        children: [
          {
            key: 'label',
            label: 'Label',
            type: types.TEXT,
          },
          {
            key: 'url',
            label: 'URL',
            type: types.TEXT,
          },
          {
            key: 'target',
            label: 'Target',
            type: types.ENUM,
            options: ['_self', '_blank', '_parent', '_top']
          },
        ]
      },
    ]
  },
  {
    key: 'logoType',
    label: 'Logo Type (v2, v3)',
    type: types.ENUM,
    options: ['DYNAMIC', 'FULL', 'SIMPLE', 'FX SIMPLE', 'FX SIMPLE V2']
  },
  {
    key: 'customLogo',
    label: 'Custom Logo (v3) - Text or Image',
    type: types.OBJECT,
    options: false,
    children: [
      {
        key: 'text',
        label: 'Logo Text',
        type: types.TEXT,
      },
      {
        key: 'image',
        label: 'Logo Image',
        type: types.S3_ASSET_URL,
      },
    ]
  },
  {
    key: 'transparent',
    label: 'Transparent (v2, v3)',
    type: types.BOOLEAN,
  },
  {
    key: 'float',
    label: 'Float (v2, v3), allow menu to float on top all the time',
    type: types.BOOLEAN,
  },
  {
    key: 'spacer',
    label: 'Space holder for menu height (v2, v3)',
    type: types.BOOLEAN,
  },
  {
    key: 'background',
    label: 'Background, Linear Gradient (v2, v3)',
    type: types.OBJECT,
    children: [
      {
        key: 'gradient',
        label: 'Linear Gradient',
        type: types.TEXT,
        tooltip: 'CSS linear gradient string. Example: linear-gradient(rgb(0 0 0 / 73%) 0%, rgb(62 62 62 / 5%) 100%)',
      },
      {
        key: 'dropdownAnimationDuration',
        label: 'Dropdown Animation Duration (v3)',
        type: types.TEXT,
        tooltip: 'Animation duration in seconds. You can enter just the number (e.g., "0.15" or "0.5"). Examples: 0.15, 0.2, 0.3, 0.5, 1, 2',
      },
      {
        key: 'dropdownAnimationTiming',
        label: 'Dropdown Animation Timing (v3)',
        type: types.ENUM,
        options: [
          'ease',
          'ease-in',
          'ease-out',
          'ease-in-out',
          'linear',
          'cubic-bezier(0.4, 0, 0.2, 1)',
          'cubic-bezier(0.25, 0.1, 0.25, 1)',
        ],
      },
      {
        key: 'dropdownExtensionHeight',
        label: 'Dropdown Extension Height (v3) - Leave empty for auto-calculate',
        type: types.TEXT,
        tooltip: 'Manual height in pixels for the dropdown extension area. Leave empty to automatically calculate based on the number of dropdown items. Example: 200 (for 200px)',
      },
    ],
  },
  {
    key: 'menuBarHeight',
    label: 'Menu Bar Height (v3)',
    type: types.OBJECT,
    children: [
      {
        key: 'desktop',
        label: 'Desktop Height',
        type: types.TEXT,
        tooltip: 'Desktop menu bar height in pixels. Default: 60. Example: 80',
      },
      {
        key: 'mobile',
        label: 'Mobile Height',
        type: types.TEXT,
        tooltip: 'Mobile menu bar height in pixels. Default: 46. Example: 56',
      },
    ],
  },
  {
    key: 'hamburgerMenuColor',
    label: 'Hamburger Menu Color (v3)',
    type: types.TEXT,
  },
  {
    key: 'centerLinks',
    label: 'Center Links (v2)',
    type: types.ARRAY,
    options: false,
    children: [
      {
        key: 'label',
        label: 'Label',
        type: types.TEXT,
      },
      {
        key: 'url',
        label: 'URL',
        type: types.TEXT,
      },
      {
        key: 'prompt',
        label: 'Prompt',
        type: types.OBJECT,
        children: [
          {
            key: 'title',
            label: 'Title',
            type: types.TEXT,
          },
          {
            key: 'message',
            label: 'Message',
            type: types.TEXT,
          },
          {
            key: 'cancelText',
            label: 'Cancel Button Text',
            type: types.TEXT,
          },
          {
            key: 'actionText',
            label: 'Action Button Text',
            type: types.TEXT,
          },
        ],
      },
    ]
  },
  {
    key: 'button',
    label: 'Button (v2)',
    type: types.OBJECT,
    children: [
      {
        key: 'label',
        label: 'Button Label',
        type: types.TEXT,
      },
      {
        key: 'url',
        label: 'Button URL',
        type: types.TEXT,
      },
      {
        key: 'variant',
        label: 'Button Variant',
        type: types.ENUM,
        options: ['dark', 'light', 'outlineDark', 'primary', 'outlinePrimary', 'outlineClear'],
      },
    ]
  },
  {
    key: 'appOnlySettings',
    label: 'App Only Settings',
    type: types.OBJECT,
    children: [
      {
        key: 'showInAppOnly',
        label: 'Show Menu When APPONLY=1',
        tooltip: 'When enabled, this menu will be displayed even when APPONLY=1 is in the URL parameters',
        type: types.BOOLEAN,
      },
      {
        key: 'topOffset',
        label: 'Menu Top Offset (v3 only)',
        tooltip: 'Distance from the top of the page (e.g., "20px", "2rem", or a number in pixels). Moves the menu down from the top. Only applies when APPONLY=1 is in the URL and "Show Menu When APPONLY=1" is enabled. Only works with Header version 3.',
        type: types.TEXT,
      },
    ]
  },
];

const defaultProps = {
  scroll_effect: false,
  color_theme: 'LIGHT',
  logo_link: '/',
  first_set: [
    {
      label: 'FF 91',
      url: '/ff-91',
      subnav: [
        {
          url: '/ff-91#design',
          label: 'Design'
        },
        {
          url: '/ff-91#performance',
          label: 'Performance'
        },
        {
          url: '/ff-91#technology',
          label: 'Technology'
        },
        {
          url: '/ff-91#interior',
          label: 'Interior'
        }
      ]
    },
    {
      label: 'DESIGN YOURS',
      url: '/futuresight'
    },
    {
      label: 'APP',
      url: '/mobile-app'
    },
    {
      label: 'INVESTORS',
      url: 'https://investors.ff.com/'
    },
  ],
  second_set: [
    {
      label: 'SIGN IN',
      url: '/account',
      loggedInLabel: 'My FF'
    }
  ],
  hero_button: {
    label: 'PREORDER YOURS',
    url: '/preorder',
  },
  drawerLinks: [
    {
      label: 'Home',
      url: '/',
    },
    {
      label: 'Sign In',
      url: '/us/account/login',
      loggedInLabel: 'My FF',
      loggedInLabelUrl: '/us/MyFF',
    },
    {
      label: 'FF 91',
      url: '/us/ff-91',
    },
    {
      label: 'App',
      url: '/us/mobile-app',
    },
    {
      label: 'Investors',
      url: 'https://investors.ff.com/'
    },
    {
      label: 'Press Room',
      url: '/us/press-room'
    },
    {
      label: 'Contact Us',
      url: '/us/contact-us'
    },
  ],
  logoType: 'DYNAMIC',
  centerLinks: [],
  button: null,
  customLogo: {
    image: 'https://genesis-cdn.ff.com/cxc10/original/AIxC-logo.png'
  },
  menuLinks: [
    {
      label: 'HOME',
      url: '/',
    },
    {
      label: 'Treasury & C10',
      url: '',
      subnav: [
        {
          label: 'C10 ETP',
          url: '',
        },
        {
          label: 'C10 Treasury',
          url: '',
        },
        {
          label: 'C10 Index',
          url: '',
        },
      ],
    },
    {
      label: 'BesTrade',
      url: '',
    },
    {
      label: 'EAIRWA',
      url: '',
      subnav: [
        {
          label: 'RWA',
          url: '',
        },
        {
          label: 'C10 Stablecoin',
          url: '',
        },
        {
          label: 'AlxC Ecosystem',
          url: '',
        },
      ],
    },
    {
      label: 'Community',
      url: '',
    },
  ],
  appOnlySettings: {
    showInAppOnly: false,
    topOffset: '',
  }
};

export default {
  title: 'Menu Bar',
  id: 'MenuBar',
  propsSchema,
  defaultProps
};
